// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9da31c58","455":"9d5569f6","488":"bff02a50"}[chunkId] + ".chunk.js";
};